<template>
  <div>
  <v-row no-gutters style="border-bottom: 1px solid #CCCCCC80">
    <v-col
      cols="12"
      md="5"
      style="padding:10px"
    >
      <b>
        {{ $t('booking.formFields.name', locale) }}
      </b>
    </v-col>
    <v-col
      cols="12"
      md="4"
      style="padding:10px"
    >
      <b>
        {{ $t('booking.formFields.type', locale) }}
      </b>
    </v-col>
    <v-col
      cols="12"
      md="1"
      style="padding:10px"
    >
      <b>
        (*)
      </b>
    </v-col>
    <v-col
      cols="12"
      md="2"
      style="padding:10px"
    >
    </v-col>
  </v-row>
  <draggable
    v-model="items"
    :draggable="'.itemDraggable'"
    style="width:100%;"
    v-bind="dragOptions"
    @start="handleSortStart"
    @end="handleSortItems(items)"
  >
    <v-row 
      v-for="item in items" 
      :key="item.id" 
      v-bind:class="'itemDraggable'"
      style="padding: 0;margin: 0;cursor: pointer;"
    >
    <v-col
      cols="12"
      md="5"
    >
      {{ getTranslation(item.label, locale) }}
    </v-col>
    <v-col
      cols="12"
      md="4"
    >
    {{ item.type }}
    </v-col>
    <v-col
      cols="12"
      md="1"
    >
     {{ item.required ? '*' : '' }}
    </v-col>
    <v-col
      cols="12"
      md="2"
      style="text-align: right;"
    >
      <v-icon
        small
        color="primary"
        @click="onEdit(item, isOwner)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        color="red"
        @click="onDelete(item.id)"
      >
        mdi-delete
      </v-icon>
    </v-col>
  </v-row>
  </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import utils from '@/services/utils'
export default {
  name: 'formFieldsTable',
  components: {
    draggable,
  },
  props: {
    formFields: {
      type: Array,
      required: true,
    },
    locale: {
      type: String,
      default: null,
    },
    onEdit: {
      type: Function,
      required: true,
    },
    onDelete: {
      type: Function,
      required: true,
    },
    isOwner: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [],
  }),
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      }
    }
  },
  watch: {
    formFields () {
      this.items = this.formFields
    },
  },
  mounted () {
    this.items = this.formFields
  },
  methods: {
    getTranslation(v, locale) {
      return utils.getTranslation(v, locale)
    },
    handleSortItems (v) {
      console.log(v)
      /*this.data = v
      if (this.data && this.data.length)
        for (let i = 0; i < this.data.length; i++) {
          this.data[i].ORD = i
        }*/
    },
    handleSortStart () {
    },
  }
}
</script>

